import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=f4fae1b2&scoped=true"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetConfirm.vue?vue&type=style&index=0&id=f4fae1b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fae1b2",
  null
  
)

export default component.exports